module.exports = __webpack_public_path__ + "yahoo--4b70a993.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/namidia/yahoo.png
// module id = 202
// module chunks = 0